/* Presentation only: Kaching owns selection, quantities, pricing and cart submission.
   The summary stepper (STR-147) only presses Kaching's own controls and never prices anything. */
(() => {
  'use strict';
  if (window.sedrQuantityOfferLoaded) return;
  window.sedrQuantityOfferLoaded = true;
  const instances = new Map();
  const ar = (document.documentElement.lang || 'ar').startsWith('ar');
  const words = ar ? {
    title: 'وفّر أكثر',
    upto: 'حتى ', total: 'الإجمالي', unit: 'سعر الحبة', before: 'قبل ', after: 'بعد ', quantity: 'الكمية: ', pending: 'اختر الكمية المناسبة لك',
    saving: 'اختر كمية أكبر للاستفادة من الخصم', count: 'الكمية', less: 'خفض الكمية', more: 'زيادة الكمية'
  } : {
    title: 'Save more',
    upto: 'Up to ', total: 'Total', unit: 'Unit price', before: 'Before ', after: 'After ', quantity: 'Quantity: ', pending: 'Choose your quantity',
    saving: 'Choose more to save', count: 'Quantity', less: 'Decrease quantity', more: 'Increase quantity'
  };
  const text = (root, selector) => (root.querySelector(selector)?.textContent || '').trim();
  const setText = (node, value) => { if (node.textContent !== value) node.textContent = value; };
  const number = value => Number(value.replace(/[٠-٩]/g, n => '٠١٢٣٤٥٦٧٨٩'.indexOf(n)).replace(/[۰-۹]/g, n => '۰۱۲۳۴۵۶۷۸۹'.indexOf(n)).replace(',', '.'));
  const priceText = price => price ? [...price.childNodes].filter(n => n.nodeType === Node.TEXT_NODE).map(n => n.textContent).join('').trim() : '';
  function nativeSaving(bar) {
    const saving = text(bar, '.kaching-bundles__bar-label');
    const currency = priceText(bar.querySelector('.kaching-bundles__bar-price')).replace(/[\d٠-٩۰-۹\s.,٬٫+-]/g, '');
    // Show only a nonzero money saving supplied by Kaching, never a promotional label.
    return currency && /[1-9١-٩۱-۹]/.test(saving) && !/[%٪]/.test(saving) && saving.replace(/[\s.,٬٫]/g, '').includes(currency) ? saving : '';
  }
  function node(tag, className, value) {
    const el = document.createElement(tag); el.className = className;
    if (value) el.textContent = value;
    return el;
  }
  const pick = bars => bars.find(bar => bar.classList.contains('kaching-bundles__bar--selected') || bar.querySelector('input[type="radio"]')?.checked);
  // Tier minimums come from Kaching's published deal settings; no price is derived from them.
  let minimums = null;
  function readMinimums() {
    const found = new Map();
    document.querySelectorAll('script.kaching-bundles-deal-block-settings').forEach(script => {
      try {
        (JSON.parse(script.textContent).dealBars || []).forEach(deal => {
          if (deal.dealBarType === 'quantity-break' && Number.isInteger(deal.quantity) && deal.quantity > 0) found.set(String(deal.id), deal.quantity);
        });
      } catch (error) { /* Unreadable settings keep the stepper inside the selected tier. */ }
    });
    return found;
  }
  function tiers(bars) {
    const ids = bars.map(bar => bar.getAttribute('data-deal-bar-id'));
    if (!minimums || !ids.every(id => minimums.has(id))) minimums = readMinimums();
    const list = ids.map(id => minimums.get(id));
    // Tiers are switched only when every row is a known quantity break in ascending order.
    return list.length > 1 && list.every((min, i) => min && (!i || min > list[i - 1])) ? list : null;
  }
  function controls(bar) {
    const input = bar?.querySelector('.kaching-bundles__quantity-selector__input');
    const buttons = bar ? bar.querySelectorAll('.kaching-bundles__quantity-selector__button') : [];
    const amount = input ? number(input.value) : 0;
    // An amount of 0 is a field that holds no quantity: Kaching leaves an entry it refused in its field.
    return input && buttons.length === 2 ? { input, amount: Number.isInteger(amount) && amount > 0 ? amount : 0, less: buttons[0], more: buttons[1] } : null;
  }
  const off = button => button.getAttribute('aria-disabled') === 'true';
  const flag = (button, disabled) => { if (button.getAttribute('aria-disabled') !== String(disabled)) button.setAttribute('aria-disabled', String(disabled)); };
  // Kaching ignores scripted input values, so a quantity moves only through its own buttons.
  const press = (button, times) => { for (let i = 0; i < times; i++) button.click(); };
  // A move is made only within this many presses a step, and dropped after this many steps or this long (ms) without a redraw.
  const reach = 500, steps = 8, patience = 400;
  const aim = (list, goal) => list.reduce((want, min, i) => min <= goal ? i : want, 0);
  // A number typed far beyond the tiers stays where Kaching has it: a move cut short would end on a quantity nobody chose.
  const far = (index, amount, goal, list, want) => (index === want ? Math.abs(goal - amount) : Math.max(amount - list[index], goal - list[want])) > reach;
  let serial = 0;
  function attach(block) {
    if (instances.has(block) || !block.querySelector('.kaching-bundles__bars') || !block.querySelector('.kaching-bundles__bar-title')) return;
    // Only enhance quantity-break offers with the existing radio-based bars.
    if (!block.querySelector('.kaching-bundles__bar > input[type="radio"]')) return;
    const panel = node('div', 'sedr-quantity-offer');
    const toggle = node('button', 'sedr-quantity-offer__toggle'); toggle.type = 'button';
    const icon = node('span', 'sedr-quantity-offer__icon', '%'); icon.setAttribute('aria-hidden', 'true');
    const content = node('span', 'sedr-quantity-offer__heading');
    const line = node('span', 'sedr-quantity-offer__line');
    const heading = node('span', 'sedr-quantity-offer__title', words.title);
    const badge = node('span', 'sedr-quantity-offer__badge');
    const arrow = node('span', 'sedr-quantity-offer__arrow'); arrow.setAttribute('aria-hidden', 'true');
    line.append(heading, badge); content.append(line); toggle.append(icon, content, arrow);
    const summary = node('div', 'sedr-quantity-offer__summary');
    const chosen = node('span', 'sedr-quantity-offer__chosen');
    const chosenText = node('span', 'sedr-quantity-offer__chosen-text');
    const stepper = node('span', 'sedr-quantity-offer__stepper');
    const stepLess = node('button', 'sedr-quantity-offer__step'); stepLess.type = 'button'; stepLess.setAttribute('aria-label', words.less);
    const stepCount = node('span', 'sedr-quantity-offer__count');
    const stepMore = node('button', 'sedr-quantity-offer__step sedr-quantity-offer__step--more'); stepMore.type = 'button'; stepMore.setAttribute('aria-label', words.more);
    stepper.append(stepLess, stepCount, stepMore); chosen.append(chosenText, stepper);
    // The announcement lives apart from the buttons, so a change is read without their labels.
    const status = node('span', 'sedr-quantity-offer__status');
    status.setAttribute('aria-live', 'polite'); status.setAttribute('aria-atomic', 'true');
    const prices = node('span', 'sedr-quantity-offer__prices');
    const unitLine = node('span', 'sedr-quantity-offer__unit-line');
    const unitLabel = node('span', 'sedr-quantity-offer__unit-label', words.unit);
    const unitPrices = node('span', 'sedr-quantity-offer__unit-prices');
    const before = node('span', 'sedr-quantity-offer__before');
    const beforeLabel = node('span', 'sedr-quantity-offer__before-label', words.before);
    const beforeMoney = node('del', 'sedr-quantity-offer__before-money');
    before.append(beforeLabel, beforeMoney);
    const unitAfter = node('span', 'sedr-quantity-offer__unit-after');
    const total = node('span', 'sedr-quantity-offer__total');
    const detail = node('span', 'sedr-quantity-offer__detail');
    prices.append(total); unitPrices.append(before, unitAfter); unitLine.append(unitLabel, unitPrices);
    summary.append(chosen, prices, unitLine, detail, status);
    block.before(panel); panel.append(toggle, block, summary);
    block.id ||= 'sedr-quantity-options-' + (++serial);
    toggle.setAttribute('aria-controls', block.id);
    const state = { block, panel, toggle, summary, chosen, total, detail, badge, open: false, scheduled: false, goal: null, kept: false, lifted: false, rounds: 0, failed: '', refocus: '', pressed: '', pressedAt: 0, typing: null };
    instances.set(block, state);
    // One step toward the wanted quantity per redraw: Kaching redraws in a microtask after a press, and the next update continues there.
    function seek(bars, index, now, list) {
      const seen = index + ':' + now.amount;
      // A press Kaching has not drawn yet is neither judged nor repeated; pressing again would count twice.
      if (state.pressed === seen && performance.now() - state.pressedAt < patience) { schedule(); return true; }
      // With no number to seek, the count Kaching kept is the one it shows after a press up, less that press.
      if (!state.goal && now.amount) state.goal = now.amount - 1;
      const goal = state.goal;
      const want = state.kept ? index : aim(list, goal);
      if (goal && index === want && now.amount === goal) {
        // Kaching redraws its counter inside the new tier, so focus held there is carried over.
        if (state.refocus && !block.contains(document.activeElement)) now[state.refocus].focus({ preventScroll: true });
        state.goal = null; state.failed = ''; state.refocus = ''; state.pressed = ''; state.kept = false; state.lifted = false;
        return false;
      }
      const main = bars[want].querySelector('.kaching-bundles__bar-main');
      if (state.pressed === seen || ++state.rounds > steps || !main || far(index, now.amount, goal, list, want)) {
        // Give up where Kaching stopped, and remember it so the same state is not chased again.
        // A press that only made Kaching show its count is taken back.
        if (state.lifted && state.pressed !== seen) press(now.less, 1);
        state.goal = null; state.failed = seen; state.refocus = ''; state.pressed = ''; state.kept = false; state.lifted = false;
        return false;
      }
      state.pressed = seen; state.pressedAt = performance.now();
      // Kaching leaves a number it refused in its field (one under the tier's minimum, or none at all)
      // and draws its own count again only when that count changes: one press up shows it.
      const lift = now.amount < list[index];
      if (lift) press(now.more, 1);
      // Each tier remembers its own quantity; leave it at its minimum, so its row keeps the total of the offer it names.
      else if (index !== want && now.amount > list[index]) press(now.less, now.amount - list[index]);
      else if (index !== want) main.click();
      else press(now.amount < goal ? now.more : now.less, Math.abs(goal - now.amount));
      state.lifted = lift;
      // Continue before any other event, so a click on the page never meets a half-made move.
      Promise.resolve().then(update);
      return true;
    }
    function update() {
      state.scheduled = false;
      const bars = [...block.querySelectorAll('.kaching-bundles__bar')];
      if (!bars.length) return;
      const selected = pick(bars);
      let max = 0;
      bars.forEach(bar => {
        const subtitle = text(bar, '.kaching-bundles__bar-subtitle');
        const match = subtitle.match(/([\d٠-٩۰-۹]+(?:[.,][\d٠-٩۰-۹]+)?)\s*[%٪]/);
        if (match) max = Math.max(max, number(match[1]));
        const saving = nativeSaving(bar);
        const firstLine = bar.querySelector('.kaching-bundles__bar-first-line');
        const secondLine = bar.querySelector('.kaching-bundles__bar-second-line');
        if (saving && firstLine && secondLine) {
          let savingLabel = secondLine.querySelector('.sedr-quantity-offer__saving');
          if (!savingLabel) { savingLabel = node('span', 'sedr-quantity-offer__saving'); secondLine.append(savingLabel); }
          setText(savingLabel, saving);
          let rate = firstLine.querySelector('.sedr-quantity-offer__rate');
          if (match && !rate) { rate = node('span', 'sedr-quantity-offer__rate'); firstLine.append(rate); }
          if (rate) { rate.hidden = !match; setText(rate, match ? match[0] : ''); }
          if (!bar.hasAttribute('data-sedr-saving')) bar.setAttribute('data-sedr-saving', 'true');
        } else {
          bar.querySelector('.sedr-quantity-offer__saving')?.remove();
          bar.querySelector('.sedr-quantity-offer__rate')?.remove();
          bar.removeAttribute('data-sedr-saving');
        }
        const active = bar === selected;
        const main = bar.querySelector('.kaching-bundles__bar-main');
        if (main && main.getAttribute('aria-pressed') !== String(active)) main.setAttribute('aria-pressed', String(active));
        // Flag actual totals; do not calculate or replace Kaching's money strings.
        const secondary = bar.querySelector('.kaching-bundles__bar-pricing-row--secondary');
        if (secondary && !bar.hasAttribute('data-sedr-total-row')) bar.setAttribute('data-sedr-total-row', 'true');
        if (!secondary && bar.hasAttribute('data-sedr-total-row')) bar.removeAttribute('data-sedr-total-row');
        if (secondary && !secondary.querySelector('.sedr-quantity-offer__price-label')) {
          secondary.prepend(node('span', 'sedr-quantity-offer__price-label', words.total));
        }
        const original = secondary?.querySelector('.kaching-bundles__bar-full-price');
        if (original && priceText(original)) bar.setAttribute('data-sedr-original-total', 'true');
        else bar.removeAttribute('data-sedr-original-total');
      });
      badge.hidden = !max; setText(badge, max ? words.upto + max + '%' : '');
      const now = selected ? controls(selected) : null;
      const list = now ? tiers(bars) : null;
      const index = bars.indexOf(selected);
      // A tier drawn a moment before its counter does not end a move; one that stays that way does.
      if (!list && state.goal !== null && performance.now() - state.pressedAt < patience) schedule();
      else if (!list) { state.goal = null; state.pressed = ''; state.kept = false; state.lifted = false; }
      else if (state.goal === null && !(state.typing && state.typing === document.activeElement) && state.failed !== index + ':' + now.amount && (now.amount < list[index] || (index + 1 < list.length && now.amount >= list[index + 1]))) {
        // A quantity raised past the next minimum in Kaching's own counter is charged at that tier, so show that tier.
        // A number typed under the tier's minimum is refused by Kaching yet stays in its field: it is sought in the tier it fits,
        // and an entry that fits none (empty, zero) gives way to the count Kaching kept in this tier.
        // A number still being typed is not Kaching's yet; it takes it when the field loses focus.
        state.goal = now.amount >= list[0] ? now.amount : 0; state.kept = !state.goal; state.rounds = 0;
        state.refocus = ['more', 'input', 'less'].find(key => now[key] === document.activeElement) || '';
      }
      // While a move is in progress the summary keeps its last settled values.
      const moving = state.goal !== null && (!list || seek(bars, index, now, list));
      // With no native selection, avoid falsely reporting a quantity as chosen.
      if (!selected && !moving) {
        setText(chosenText, words.pending); stepper.hidden = true; setText(total, ''); setText(detail, words.saving);
        before.hidden = true; setText(beforeMoney, '');
        unitLine.hidden = true; setText(unitAfter, ''); setText(status, '');
      } else if (!moving) {
        const quantity = selected.querySelector('.kaching-bundles__quantity-selector__input');
        const count = quantity?.value;
        const amount = count ? number(count) : 0;
        const quantityLabel = ar ? (amount === 1 ? 'عبوة واحدة' : amount === 2 ? 'عبوتان' : count + (amount >= 3 && amount <= 10 ? ' عبوات' : ' عبوة')) : count + (amount === 1 ? ' bottle' : ' bottles');
        const counted = now && now.amount > 0;
        stepper.hidden = !counted;
        setText(chosenText, counted ? words.count : Number.isInteger(amount) && amount > 0 ? words.quantity + quantityLabel : text(selected, '.kaching-bundles__bar-title'));
        if (counted) {
          setText(stepCount, count);
          flag(stepLess, list ? now.amount <= list[0] : off(now.less));
          flag(stepMore, off(now.more));
        }
        const price = selected.querySelector('.kaching-bundles__bar-pricing-row--secondary .kaching-bundles__bar-price') || selected.querySelector('.kaching-bundles__bar-price');
        const money = priceText(price);
        const unitMoney = priceText(selected.querySelector('.kaching-bundles__bar-pricing-row--main .kaching-bundles__bar-price'));
        const unitOriginal = priceText(selected.querySelector('.kaching-bundles__bar-pricing-row--main .kaching-bundles__bar-full-price'));
        setText(beforeMoney, unitOriginal); before.hidden = !unitOriginal;
        setText(unitAfter, unitMoney ? (unitOriginal ? words.after : '') + unitMoney : '');
        unitLine.hidden = !unitMoney || !selected.hasAttribute('data-sedr-total-row');
        setText(total, money ? words.total + ' ' + money : '');
        const subtitle = text(selected, '.kaching-bundles__bar-subtitle');
        const rate = subtitle.match(/([\d٠-٩۰-۹]+(?:[.,][\d٠-٩۰-۹]+)?)\s*[%٪]/);
        const percent = rate && number(rate[1]) > 0 ? rate[0] : '';
        const saving = nativeSaving(selected);
        setText(detail, saving ? saving + (percent ? ' (' + percent + ')' : '') : (percent ? subtitle : ''));
        setText(status, [counted ? words.quantity + count : chosenText.textContent, total.textContent, detail.textContent].filter(Boolean).join(ar ? '، ' : ', '));
      }
      if (toggle.getAttribute('aria-expanded') !== String(state.open)) toggle.setAttribute('aria-expanded', String(state.open));
      panel.classList.toggle('sedr-quantity-offer--open', state.open);
      // Rows already show the quantities and totals while open.
      summary.hidden = !selected || state.open;
      detail.hidden = !detail.textContent;
      block.hidden = !state.open;
    }
    function schedule() {
      if (!state.scheduled) { state.scheduled = true; requestAnimationFrame(update); }
    }
    function step(delta) {
      const bars = [...block.querySelectorAll('.kaching-bundles__bar')];
      const selected = pick(bars);
      const now = controls(selected);
      if (!now || !now.amount) return;
      const list = tiers(bars);
      // Quick presses add up on the quantity already being sought.
      const goal = (state.goal || now.amount) + delta;
      // Without known tiers, or beyond their reach, the step is Kaching's own inside the selected tier.
      if (!list || far(bars.indexOf(selected), now.amount, goal, list, aim(list, goal))) {
        const button = delta > 0 ? now.more : now.less;
        if (!off(button)) button.click();
        return;
      }
      if (goal < list[0] || (delta > 0 && off(now.more))) return;
      state.goal = goal; state.kept = false; state.rounds = 0; state.failed = ''; state.refocus = '';
      update();
    }
    stepper.addEventListener('click', event => {
      const button = event.target.closest('.sedr-quantity-offer__step');
      if (button && !off(button)) step(button === stepMore ? 1 : -1);
    });
    toggle.addEventListener('click', () => { state.open = !state.open; update(); });
    block.addEventListener('click', schedule);
    block.addEventListener('input', event => { state.typing = event.target.matches('.kaching-bundles__quantity-selector__input') ? event.target : null; schedule(); });
    // Kaching takes a typed number when its field loses focus (not on Enter), so a move it refused before is tried again then.
    block.addEventListener('focusout', () => { state.typing = null; state.failed = ''; schedule(); });
    state.observer = new MutationObserver(schedule);
    state.observer.observe(block, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'checked', 'value'] });
    block.setAttribute('data-sedr-quantity-offer', 'true');
    // Hide only after a fully usable toggle and summary have been installed.
    update();
  }
  function scan() {
    for (const [block, state] of instances) {
      if (!block.isConnected) {
        state.observer.disconnect();
        // Kaching may replace its root inside our panel when a variant changes.
        // Unwrap the replacement before disposing only our presentation nodes.
        state.panel.querySelectorAll('.kaching-bundles__block').forEach(replacement => state.panel.before(replacement));
        state.panel.remove(); instances.delete(block);
      }
    }
    document.querySelectorAll('main .kaching-bundles__block--loaded').forEach(attach);
  }
  let pending = false;
  const discovery = new MutationObserver(records => {
    const isBlock = item => item.nodeType === 1 && (item.matches('.kaching-bundles__block') || item.querySelector('.kaching-bundles__block'));
    if (records.every(record => record.target.closest?.('.sedr-quantity-offer') && ![...record.addedNodes, ...record.removedNodes].some(isBlock))) return;
    if (!pending) { pending = true; requestAnimationFrame(() => { pending = false; scan(); }); }
  });
  function start() {
    scan(); discovery.observe(document.querySelector('main') || document.body, { subtree: true, childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
})();
